<template>
    <div>

        <el-row class="column-name" justify="start">
            <span>关联工单</span>
            <div class="navbar-right">
                <el-dropdown trigger="click">
                    <el-button type="info" plain size="minimum" class="fa fa-plus-circle">
                        新增关联
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native='addClickHandle(`WORKORDER`)'>作业</el-dropdown-item>
                        <el-dropdown-item @click.native='addClickHandle(`CHANGE`)'>变更</el-dropdown-item>
                        <el-dropdown-item @click.native='addClickHandle(`INCIDENT`)'>事件</el-dropdown-item>
                        <el-dropdown-item @click.native='addClickHandle(`PROBLEM`)'>问题</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>&nbsp;&nbsp;
                <el-dropdown trigger="click">
                    <el-button type="info" plain size="minimum" class="fa fa-plus-circle">
                        选择关联
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native='choiceClickHandle(`WORKORDER`)'>作业</el-dropdown-item>
                        <el-dropdown-item @click.native='choiceClickHandle(`CHANGE`)'>变更</el-dropdown-item>
                        <el-dropdown-item @click.native='choiceClickHandle(`INCIDENT`)'>事件</el-dropdown-item>
                        <el-dropdown-item @click.native='choiceClickHandle(`PROBLEM`)'>问题</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </el-row>
        <el-row>
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column prop="roomName" style="" label="数据中心">
                </el-table-column>
                <el-table-column prop="relatedrecclass" label="业务类型">
                </el-table-column>
                <el-table-column prop="relatedreckey" label="编号">
                    <template slot-scope="scope">
                        <el-button @click="openWindowClickHandler(scope.row)" type="text">{{scope.row.relatedreckey}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="名称">
                </el-table-column>
                <el-table-column prop="status" label="状态">
                </el-table-column>
                <el-table-column prop="relationType" label="关联关系">
                </el-table-column>
                <el-table-column prop="enterBy" label="创建人">
                </el-table-column>
                <el-table-column prop="enterDate" label="创建时间">
                </el-table-column>
                <el-table-column label="操作" v-if="hasPermission('menu.newTicket.cancelRelation')" >
                    <template slot-scope="scope">
                        <el-button @click="btnDeleteRelationHandler(scope.row)" size="small" type="danger">解除关联
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <br>

        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination align="right" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-row>

        <WorkorderRelationDialog
                ref="workorderRelationDialogRef"
                :masterInfo="masterInfo"
                :searchParams="workorderRelationSearchParams"
                :visible.sync="workorderRelationDialogVisible"
                @afterRelation="afterRelation">
        </WorkorderRelationDialog>

        <IncidentRelationDialog
                ref="ticketRelationDialogRef"
                :masterInfo="masterInfo"
                :searchParams="incidentRelationSearchParams"
                :visible.sync="incidentRelationDialogVisible"
                @afterRelation="afterRelation">
        </IncidentRelationDialog>

        <ProblemRelationDialog
                ref="problemRelationDialogRef"
                :masterInfo="masterInfo"
                :searchParams="problemRelationSearchParams"
                :visible.sync="problemRelationDialogVisible"
                @afterRelation="afterRelation">
        </ProblemRelationDialog>
    </div>
</template>

<script>
import RelationServer from "@/api/relation/relation";
import DomainalnApi from "@/api/domainaln";
import {formatDate} from 'element-ui/lib/utils/date-util'
import WorkorderRelationDialog from '@/components/relation/workorderRelationDialog'
import IncidentRelationDialog from '@/components/relation/incidentRelationDialog'
import ProblemRelationDialog from '@/components/relation/problemRelationDialog'

import CommonServiceApi from '@/api/commonService/index'

export default {
        name: "relation",

        components: {
            WorkorderRelationDialog,
            IncidentRelationDialog,
            ProblemRelationDialog,
        },

        data() {
            return {
                tableData: [],

                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],
                total: 0,

                roomMap: null,

                workorderStatusMap: null,
                changeStatusMap: null,
                incidentStatusMap: null,
                problemStatusMap: null,

                relationTypeMap: {
                    'RELATED': '相关',
                    'ORIGINAL': '原始记录',
                    'SUBSEQUENT': '后续',
                },

                workorderRelationDialogVisible: false,
                incidentRelationDialogVisible: false,
                problemRelationDialogVisible: false,

                workorderRelationSearchParams: {
                    'woclass': '',
                    'description': '',
                    'roomid': '',
                    'roomids': [],
                    'workorder': '',
                },

                incidentRelationSearchParams: {
                    'clazz': '',
                    'ticketid': '',
                    'description': '',
                },

                problemRelationSearchParams: {
                    'clazz': '',
                    'ticketid': '',
                    'description': '',
                    'statusArr': [],
                },

                masterInfo: {},
            }
        },

        props: {
            master: {
                type: String,
            },
            masterKey: {
                type: String,
            },
            rooms: {
                type: Array,
            },
            assetId: {
                type: Number,
            },
            assetTag: {
                type: String,
            },
            roomId: {
                type: Number,
            },
            level: {
                type: String,
            },
            authorized: {
                type: String,
            },
            location: {
                type: String,
            },
            tickettype: {
                type: String,
            },
            failurecode: {
                type: String,
            },
            failuretype: {
                type: String,
            },
            problemcode: {
                type: String,
            },
            source: {
                type: String,
            },
            orgid: {
                type: String,
            },
            siteid: {
                type: String,
            },
            description: {
                type: String,
            },
            memo: {
                type: String,
            },
            actualstart: {
                type: String,
            }
        },

        methods: {
            async addClickHandle(type) {
                switch (type) {
                    case 'INCIDENT':
                        await this.addIncidentRelation(type);
                        break;
                    case 'PROBLEM':
                        await this.addProblemRelation(type);
                        break;
                    case 'WORKORDER':
                        await this.addWorkorderRelation(type);
                        break;
                    case 'CHANGE':
                        await this.addChangeRelation(type);
                        break;
                }
                await this.queryPage(this.masterKey);
            },

            async addWorkorderRelation(type) {
                let d1 = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                let d2 = formatDate(new Date(), 'yyyy-MM-dd HH:mm');
                let params = {
                    'enterBy': localStorage.getItem('realname'),
                    'enterDate': d1,
                    'relationType': 'SUBSEQUENT',
                    'master': {
                        'autoSave': false,
                        'key': this.masterKey,
                        'orgId': localStorage.getItem('authorg'),
                        'siteId': localStorage.getItem('defsite'),
                    },
                    'slave': {
                        'asset': this.assetId,
                        'assettag': this.assetTag,
                        'autoSave': true,
                        'description': this.description,
                        'enterby': localStorage.getItem('username'),
                        'enterbyname': localStorage.getItem('realname'),
                        'enterdate': d1,
                        'orgId': localStorage.getItem('authorg'),
                        'siteId': localStorage.getItem('defsite'),
                        'roomid': this.roomId,
                        'schedstart': d2,
                        'woclass': type,
                        'workorderstatus': 'DRAFT',
                    },
                }
                await RelationServer.relation(this.master, this.masterKey, type, params).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('新增成功');
                    }
                });
            },

            async addChangeRelation(type) {
                let d1 = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                let d2 = formatDate(new Date(), 'yyyy-MM-dd HH:mm');
                let level = this.level != null ? this.level : 'LEVEL3';
                let authorized = this.authorized != null ? this.authorized : this.level === 'LEVEL1' || this.level === 'LEVEL2' ? '1' : null;
                let params = {
                    'enterBy': localStorage.getItem('realname'),
                    'enterDate': d1,
                    'relationType': 'SUBSEQUENT',
                    'master': {
                        'autoSave': false,
                        'key': this.masterKey,
                        'orgId': localStorage.getItem('authorg'),
                        'siteId': localStorage.getItem('defsite'),
                    },
                    'slave': {
                        'asset': this.assetId,
                        'assettag': this.assetTag,
                        'autoSave': true,
                        'description': this.description,
                        'enterby': localStorage.getItem('username'),
                        'enterbyname': localStorage.getItem('realname'),
                        'enterdate': d1,
                        'orgId': localStorage.getItem('authorg'),
                        'siteId': localStorage.getItem('defsite'),
                        'roomid': this.roomId,
                        'schedstart': d2,
                        'woclass': type,
                        'workorderstatus': 'DRAFT',
                        'isemergency': 'NO',
                        'level': level,
                        'authorized': authorized,
                        'worktype': null,
                    },
                }
                await RelationServer.relation(this.master, this.masterKey, type, params).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('新增成功');
                    }
                });
            },

            async addIncidentRelation(type) {
                let d1 = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                let d2 = formatDate(new Date(), 'yyyy-MM-dd HH:mm');
                let params = {
                    'enterBy': localStorage.getItem('realname'),
                    'enterDate': d1,
                    'relationType': 'SUBSEQUENT',
                    'master': {
                        'autoSave': false,
                        'key': this.masterKey,
                        'orgId': localStorage.getItem('authorg'),
                        'siteId': localStorage.getItem('defsite'),
                    },
                    'slave': {
                        'actualstart': d1,
                        'assetid': this.assetId,
                        'assetnum': this.assetTag,
                        'autoSave': true,
                        'clazz': type,
                        'dcnum': this.roomId,
                        'description': this.description,
                        'enterby': localStorage.getItem('realname'),
                        'enterbyusername': localStorage.getItem('username'),
                        'enterdate': d1,
                        'orgId': localStorage.getItem('authorg'),
                        'siteId': localStorage.getItem('defsite'),
                        'schedstart': d2,
                        'status': 'DRAFT',
                        'memo': this.memo,
                        'level': this.level,
                        'location': this.location,
                        'source': this.source,
                        'failurecode': this.failurecode == null ? '' : this.failurecode.split('_')[1],
                        'failuretype': this.failuretype == null ? '' : this.failuretype.split('_')[1],
                        'tickettype': this.tickettype == null ? '' : this.tickettype.split('_')[1],
                        'problemcode': this.problemcode,
                    },
                }
                await RelationServer.relation(this.master, this.masterKey, type, params).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('新增成功');
                    }
                });
            },

            async addProblemRelation(type) {
                let d1 = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                let d2 = formatDate(new Date(), 'yyyy-MM-dd HH:mm');
                let params = {
                    'enterBy': localStorage.getItem('realname'),
                    'enterDate': d1,
                    'relationType': 'SUBSEQUENT',
                    'master': {
                        'autoSave': false,
                        'key': this.masterKey,
                        'orgId': localStorage.getItem('authorg'),
                        'siteId': localStorage.getItem('defsite'),
                    },
                    'slave': {
                        'actualstart': this.actualstart,
                        'assetid': this.assetId,
                        'autoSave': true,
                        'clazz': type,
                        'dcnum': this.roomId,
                        'description': this.description,
                        'enterby': localStorage.getItem('realname'),
                        'enterbyusername': localStorage.getItem('username'),
                        'enterdate': d1,
                        'orgId': localStorage.getItem('authorg'),
                        'siteId': localStorage.getItem('defsite'),
                        'schedstart': d2,
                        'status': 'DRAFT',
                        'memo': this.memo,
                        'level': this.level,
                        'location': this.location,
                        'source': this.source,
                        'failurecode': this.failurecode == null ? '' : this.failurecode.split('_')[1] ,
                        'failuretype': this.failuretype == null ? '' : this.failuretype.split('_')[1] ,
                    },
                }
                await RelationServer.relation(this.master, this.masterKey, type, params).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('新增成功');
                    }
                });
            },

            choiceClickHandle(e) {
                this.masterInfo = {
                    'clazz': this.master,
                    'recordkey': this.masterKey,
                    'relatedrecclass': e,
                    'relatetype': 'RELATED',
                    'validation': 'VALID',
                    'enterby': localStorage.getItem('realname'),
                    'enterdate': formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    'orgid': this.orgid,
                    'siteid': this.siteid,
                    'dcnum': this.roomId,
                };

                //清空表格复选框
                try {
                    this.$refs['workorderRelationDialogRef'].$refs['workorderRelationTableRef'].clearSelection();
                } catch (e) {

                }

                if (e == 'WORKORDER' || e == 'CHANGE') {
                    this.workorderRelationSearchParams.woclass = e;
                    this.workorderRelationDialogVisible = true;
                } else if (e == 'INCIDENT') {
                    this.incidentRelationSearchParams.clazz = e;
                    this.incidentRelationDialogVisible = true;
                } else if (e == 'PROBLEM') {
                    this.problemRelationSearchParams.clazz = e;
                    this.problemRelationSearchParams.statusArr = ['DRAFT', 'WAPPR', 'WCONFIRM', 'WHOPAN', 'APPROVE', 'UNDETERMINED', 'OPAPPROVE', 'SENIORAPPROVE'];
                    this.problemRelationDialogVisible = true;
                }
            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryPage(this.masterKey);
            },

            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryPage(this.masterKey);
            },

            getBussinessType(relatedrecclass) {
                switch (relatedrecclass) {
                    case 'INCIDENT':
                        return '事件';
                    case 'PROBLEM':
                        return '问题';
                    case 'WORKORDER':
                        return '工单';
                    case 'CHANGE':
                        return '变更';
                }
            },

            getRoomName(roomMap, record) {
                switch (record.relatedrecclass) {
                    case 'INCIDENT':
                        return roomMap.get(record.dcnum.toString());
                    case 'PROBLEM':
                        return roomMap.get(record.dcnum.toString());
                    case 'WORKORDER':
                        return roomMap.get(record.roomid.toString());
                    case 'CHANGE':
                        return roomMap.get(record.roomid.toString());
                }
            },

            async queryPage(masterKey) {
                if(!masterKey) return
                let pageParams = {
                    'current': this.currentPage,
                    'size': this.pageSize,
                };
                RelationServer.getRelationPageInfo(this.master, masterKey, pageParams).then(res => {
                    this.total = 0;
                    this.tableData = [];
                    if (res.data.code == 200) {
                        let records = res.data.result.records;
                        for (let i = 0; i < records.length; i++) {
                            this.tableData.push({
                                'roomName': this.getRoomName(this.roomMap, records[i]),
                                'relatedType': records[i].relatedrecclass,
                                'relatedrecclass': this.getBussinessType(records[i].relatedrecclass),
                                'relatedreckey': records[i].key,
                                'description': records[i].description,
                                'status': this.getStatusDescription(records[i]),
                                'relationType': this.getRelationType(records[i].relatetype),
                                'enterBy': this.getEnterBy(records[i]),
                                'enterDate': this.getEnterDate(records[i]),
                                'workorderid': records[i].workorderid,  //工单、变更用到
                            });
                        }
                        this.total = res.data.result.total;
                        this.$emit('afterQueryRelation', this.total);
                    }
                })
            },

            getEnterBy(record) {
                switch (record.relatedrecclass) {
                    case 'INCIDENT':
                        return record.enterby;
                    case 'PROBLEM':
                        return record.enterby;
                    case 'WORKORDER':
                        return record.enterbyname;
                    case 'CHANGE':
                        return record.enterbyname;
                }
            },

            getEnterDate(record) {
                switch (record.relatedrecclass) {
                    case 'INCIDENT':
                        return record.actualstart;
                    case 'PROBLEM':
                        return record.enterdate;
                    case 'WORKORDER':
                        return record.enterdate;
                    case 'CHANGE':
                        return record.enterdate;
                }
            },

            /**
             * 获取各业务工作流状态的映射
             */
            getStatusMap() {
                DomainalnApi.list({domainid: 'WORKORDERSTATUS'}).then(responseBody => {
                    this.workorderStatusMap = new Map();
                    for (let i = 0; i < responseBody.length; i++) {
                        this.workorderStatusMap.set(responseBody[i].value, responseBody[i].description);
                    }
                });

                DomainalnApi.list({domainid: 'CHANGESTATUS'}).then(responseBody => {
                    this.changeStatusMap = new Map();
                    for (let i = 0; i < responseBody.length; i++) {
                        this.changeStatusMap.set(responseBody[i].value, responseBody[i].description);
                    }
                });

                DomainalnApi.list({domainid: 'INCIDENTSTATUS'}).then(responseBody => {
                    this.incidentStatusMap = new Map();
                    for (let i = 0; i < responseBody.length; i++) {
                        this.incidentStatusMap.set(responseBody[i].value, responseBody[i].description);
                    }
                });

                DomainalnApi.list({domainid: 'PROBLEMSTATUS'}).then(responseBody => {
                    this.problemStatusMap = new Map();
                    for (let i = 0; i < responseBody.length; i++) {
                        this.problemStatusMap.set(responseBody[i].value, responseBody[i].description);
                    }
                });
            },

            getStatusDescription(record) {
                switch (record.relatedrecclass) {
                    case 'INCIDENT':
                        return this.incidentStatusMap.get(record.status);
                    case 'PROBLEM':
                        return this.problemStatusMap.get(record.status);
                    case 'WORKORDER':
                        return this.workorderStatusMap.get(record.workorderstatus);
                    case 'CHANGE':
                        return this.changeStatusMap.get(record.workorderstatus);
                }
            },

            getRelationType(relatetype) {
                return this.relationTypeMap[relatetype];
            },

            btnDeleteRelationHandler(row) {
                this.$confirm('确定解除关联吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    RelationServer.delete(this.master, this.masterKey, row.relatedType, row.relatedreckey).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success('解绑成功');
                            this.queryPage(this.masterKey);
                        }
                    });
                });
            },

            afterRelation() {
                this.queryPage(this.masterKey);
            },

            openWindowClickHandler(data) {
                let url = '';
                switch (data.relatedType) {
                    case 'INCIDENT':
                        url = 'ticket?m=5111&TICKETID=' + data.relatedreckey;
                        break;
                    case 'PROBLEM':
                        url = '/athub/problem/event_problem_management.html?m=510501&ticketid=' + data.relatedreckey;
                        break;
                    case 'WORKORDER':
                        url = 'athub/workOrder/job_order.html?m=6101&workorderid=' + data.workorderid;
                        break;
                    case 'CHANGE':
                        url = 'athub/change/change.html?m=5106&workorderid=' + data.workorderid;
                        break;
                }
                window.open(url, "_blank");
            },

            queryPageOper(masterKey) {
                this.roomMap = new Map();
                this.currentPage = 1;
                if (this.rooms.length == 0) {
                    CommonServiceApi.getRoomsByAuthSites().then(res => {
                        this.rooms = res.data;
                        for (let i = 0; i < this.rooms.length; i++) {
                            this.roomMap.set(this.rooms[i].id, this.rooms[i].name);
                        }
                        this.queryPage(masterKey);
                    })
                } else {
                    for (let i = 0; i < this.rooms.length; i++) {
                        this.roomMap.set(this.rooms[i].id, this.rooms[i].name);
                    }
                    this.queryPage(masterKey);
                }
            },

        },

        mounted() {
            this.getStatusMap();
        },

        watch: {
            masterKey: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    this.queryPageOper(newVal);
                }
            },

            rooms: {
                handler: function (newVal, oldVal) {
                    this.workorderRelationSearchParams.roomids = newVal.map(e => e.id);
                }
            },
        },
    }
</script>

<style scoped>

</style>
